import CheckCard from "./components/CheckCard";
import Statistic from "./components/Statistic";
import StatisticCard from "./components/StatisticCard";
import ProCard from "./ProCard";
import "antd/es/card/style";
export { StatisticCard, Statistic, CheckCard, ProCard };
export default ProCard;